import React, { FC, useState, useEffect } from 'react'
import NoOfClients from '../../../_metronic/images/numberOfClients.svg'
import NoOfAgents from '../../../_metronic/images/numberOfAgents.svg'
import TotalTPVs from '../../../_metronic/images/Totaltpvs.svg'
import { useLazyQuery } from '@apollo/client'
import { GETDASHBOARDMETRICS } from '../../../utils/GraphQLAPI'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import moment from 'moment'

const MySwal = withReactContent(Swal)

const DashboardMetrics: FC = ({ filterOptions }: any) => {
  const [dashboardData, setDashboardData] = useState<any>()
  const [getDashboardMetrics] = useLazyQuery(GETDASHBOARDMETRICS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setDashboardData(data)
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })
  const dateFormat = 'YYYY-MM-DD'
  const date = new Date()

  const _fromDate = new Date(
    moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
  ).toISOString()

  const _toDate = new Date(moment(date).format(dateFormat) + 'T23:59:00').toISOString()

  useEffect(() => {
    if (filterOptions.fromDate && filterOptions.toDate) {
      getDashboardMetrics({
        variables: {
          filter: {
            fromDate: filterOptions.fromDate || _fromDate,
            toDate: filterOptions.toDate || _toDate,
          },
        },
      })
    }
  }, [filterOptions.fromDate, filterOptions.toDate, getDashboardMetrics])


  return (
    <div className='h-164px' style={{ marginBottom: '30px' }}>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4 col-md-4 w-345px h-164px'>
          <div
            className={`card bg-primary hoverable card-xl-stretch mb-xl-8 w-345px h-164px`}
            style={{ borderRadius: '12px !important' }}
          >
            <div className='card-body'>
              <img src={NoOfClients} height='41px' width='41px' alt='img' />
              <div className={`text-white fw-700 fs-26px mb-2 mt-5`}>
                {dashboardData && dashboardData.getTpvAdminDashboardMetrics.totalClients}
              </div>
              <div className={`fw-semibold text-white`}>Number Of Clients</div>
            </div>
          </div>
        </div>
        <div className='col-xl-4 col-md-4 w-345px h-164px'>
          <div className={`card bg-success hoverable card-xl-stretch mb-xl-8 w-345px h-164px`}>
            <div className='card-body'>
              <img src={NoOfAgents} height='41px' width='41px' alt='img' />
              <div className={`text-white fw-700 fs-26px mb-2 mt-5`}>
                {dashboardData && dashboardData.getTpvAdminDashboardMetrics.totalAgents}
              </div>
              <div className={`fw-semibold text-white`}>Number Of Agents</div>
            </div>
          </div>
        </div>

        <div className='col-xl-4 col-md-4 w-345px h-164px'>
          <div className={`card bg-danger hoverable card-xl-stretch mb-xl-8  w-345px h-164px`}>
            <div className='card-body'>
              {/* <KTSVG path={svgIcon} className={`svg-icon-${iconColor} svg-icon-3x ms-n1`} /> */}
              <img src={TotalTPVs} height='41px' width='41px' alt='img' />
              <div className={`text-white fw-700 fs-26px mb-2 mt-5`}>
                {dashboardData && dashboardData.getTpvAdminDashboardMetrics.totalTpv}
              </div>
              <div className={`fw-semibold text-white`}>Total TPVs</div>
            </div>
          </div>
        </div>
      </div>
      {/* end::Row */}
    </div>
  )
}

export { DashboardMetrics }
